export const API_URL = "https://chatgpt-clone-jrmg.onrender.com/";
export const TIMEOUT_SEC = 13;
